import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SocialCapitalModel } from './social-capital.model';
import { SocialCapitalService } from './social-capital.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../../../shared/dummy.component';
import { SocialCapitalListComponent } from './social-capital-list.component';
import { AccountMovementsViewModel } from '../../../accounting/models/accounting-movement.model';
import { SharedService } from '../../../../shared/services/shared.service';

@Component({
    selector: 'app-social-capital-form',
    templateUrl: './social-capital-form.component.html',
    styleUrls: ['./social-capital-form.component.css'],
    standalone: false
})
export class SocialCapitalFormComponent implements OnInit {

  uid: number = this.data.uid;

  //AccountMovementes Import data
  movement: AccountMovementsViewModel;
  flagImport: boolean = this.data.flagImport;
  saved: boolean = false;
  //-------------------------------

  ready: boolean = false;
  amountFormControl: UntypedFormControl;
  dateIncorporationOrExtensionFormControl: UntypedFormControl;
  sharePremiumFormControl: UntypedFormControl;
  socialCapitalModel: SocialCapitalModel;
  submitted: boolean = false;

  constructor(
    private socialCapitalService: SocialCapitalService,
    private sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dummy: DummyComponent,
    public dialogRef: MatDialogRef<SocialCapitalListComponent>,
    public snackBar: MatSnackBar
  ) {
    this.socialCapitalModel = new SocialCapitalModel();
    this.amountFormControl = new UntypedFormControl();
    this.dateIncorporationOrExtensionFormControl = new UntypedFormControl();
    this.sharePremiumFormControl = new UntypedFormControl();
  }

  ngOnInit() {
    if (this.flagImport) {
      this.movement = this.data.movement;
      this.movement.type = this.data.type;
      this.socialCapitalModel.manualMovement = this.movement;
      this.socialCapitalModel.amount = this.movement.amount * -1;
      this.socialCapitalModel.dateIncorporationOrExtension = this.movement.date;

      this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
        this.socialCapitalModel.accountingModelsNumber = response;
        this.socialCapitalModel.manualMovement.accountNumber = response;
      })
    }

    this.socialCapitalModel.uid = this.uid;
    if (this.uid != undefined && this.uid !== null) {
      this.ready = false;

      this.socialCapitalService.loadData(this.uid).then(socialCapital => {
        this.socialCapitalModel = socialCapital;
        this.amountFormControl.setValue(socialCapital.amount ?? null);
        this.sharePremiumFormControl.setValue(socialCapital.sharePremium ?? null);
        this.dateIncorporationOrExtensionFormControl.setValue(socialCapital.dateIncorporationOrExtension ?? null);
        this.ready = true;
      });
    } else {
      this.ready = true;
    }
  }

  // SAVE
  onSubmit() {
    if (this.amountFormControl.invalid && this.dateIncorporationOrExtensionFormControl.invalid && this.sharePremiumFormControl.invalid) {
      this.amountFormControl.markAsTouched();
      this.dateIncorporationOrExtensionFormControl.markAsTouched();
      this.sharePremiumFormControl.markAsTouched();
    }

    if (this.isDataValid()) {
      this.submitted = true;
      this.socialCapitalModel.amount = this.amountFormControl.value;
      this.socialCapitalModel.sharePremium = this.sharePremiumFormControl.value;
      this.socialCapitalModel.dateIncorporationOrExtension = this.dateIncorporationOrExtensionFormControl.value;
      this.save(this.socialCapitalModel);
    } else {
      this.displayInfo("Compruebe los campos marcados en rojo");
      return;
    }
  }

  private isDataValid(): boolean {
    if (!this.amountFormControl.invalid && !this.dateIncorporationOrExtensionFormControl.invalid && !this.sharePremiumFormControl.invalid) {
      return true;
    }
    return false;
  }

  save(socialCapitalModel) {
    const noError = true;
    const mensajeError = '';

    if (noError) {
      if (socialCapitalModel.uid == null) {
        this.socialCapitalService.addData(socialCapitalModel)
          .then(socialCapitalModel => {
            this.socialCapitalModel = socialCapitalModel;
            if (this.data != null) {
              this.saved = true;
            } else {
              this.dummy.redirectTo('/partnersequity/capital-social');
            }
          },
            error => this.displayInfo(error.error['message'])
          )
      } else {
        this.socialCapitalService.editData(socialCapitalModel.uid, socialCapitalModel)
          .then(socialCapitalModel => {
            this.socialCapitalModel = socialCapitalModel;
            if (this.data != null) {
              this.saved = true;
            } else {
              this.dummy.redirectTo('/partnersequity/capital-social');
            }
          },
            error => this.displayInfo(error.error['message'])
          )
      }
    } else {
      this.displayInfo(mensajeError);
    }
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  closeDialog() {
    if (this.saved) { //Asiento contable creado
      this.dialogRef.close(true);
    } else { //Asiento contable no creado
      this.dialogRef.close(false);
    }
  }
}
